export type UserRole = 'ALUNO' | 'PROFESSOR' | 'FINANCEIRO' | 'COORDENADOR' | 'ADMIN';

/** Tela inicial de cada perfil (login, redirecionamento de /admin e fallback de 403). */
export const HOME_BY_ROLE: Record<UserRole, string> = {
  ADMIN: '/admin/dashboard',
  COORDENADOR: '/admin/turmas',
  FINANCEIRO: '/admin/financeiro',
  PROFESSOR: '/professor',
  ALUNO: '/portal',
};

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export interface RefreshResponse {
  accessToken: string;
  refreshToken: string;
}
